export type CreateBusinessDraft = {
  name: string
  category: string
  description: string
  phone: string
  website: string
  address: string
}

type CreateBusinessIntent = {
  originPath: string
  draft: CreateBusinessDraft
  createdAt: string
}

const KEY = 'createBusinessIntent:v1'
const TTL_MS = 2 * 60 * 60 * 1000
const SAFE_DEFAULT_ORIGIN = '/pages?create=1'

export const EMPTY_CREATE_BUSINESS_DRAFT: CreateBusinessDraft = {
  name: '',
  category: '',
  description: '',
  phone: '',
  website: '',
  address: '',
}

function sanitizeOriginPath(value: string | null | undefined): string {
  const raw = String(value || '').trim()
  if (!raw) return SAFE_DEFAULT_ORIGIN
  if (!raw.startsWith('/')) return SAFE_DEFAULT_ORIGIN
  if (raw.startsWith('//')) return SAFE_DEFAULT_ORIGIN
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(raw)) return SAFE_DEFAULT_ORIGIN
  return raw
}

export function setCreateBusinessIntent(payload: { originPath: string; draft?: Partial<CreateBusinessDraft> }) {
  try {
    const existing = getCreateBusinessIntent()
    const next: CreateBusinessIntent = {
      originPath: sanitizeOriginPath(payload.originPath || existing?.originPath || SAFE_DEFAULT_ORIGIN),
      draft: {
        ...EMPTY_CREATE_BUSINESS_DRAFT,
        ...(existing?.draft || {}),
        ...(payload.draft || {}),
      },
      createdAt: new Date().toISOString(),
    }
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {}
}

export function getCreateBusinessIntent(): CreateBusinessIntent | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as CreateBusinessIntent
    const createdTs = Date.parse(parsed?.createdAt || '')
    if (!Number.isFinite(createdTs) || Date.now() - createdTs > TTL_MS) {
      clearCreateBusinessIntent()
      return null
    }
    return {
      originPath: sanitizeOriginPath(parsed.originPath || SAFE_DEFAULT_ORIGIN),
      draft: {
        ...EMPTY_CREATE_BUSINESS_DRAFT,
        ...(parsed.draft || {}),
      },
      createdAt: parsed.createdAt,
    }
  } catch {
    return null
  }
}

export function clearCreateBusinessIntent() {
  try {
    localStorage.removeItem(KEY)
  } catch {}
}
